function off(obj, ...args) {
    if (obj && obj.removeEventListener) obj.removeEventListener(...args);
}
const src_off = off;
export default src_off;
